export function initCalendar() {
    if (!document.querySelector('.calendar-container')) return;

    const dateStr = new URLSearchParams(window.location.search).get('date');

    let currentDate, currentMonth, currentYear, day;
    if (dateStr) {
        [day, currentMonth, currentYear] = dateStr.split('.').map(Number);
        currentMonth -= 1;
        currentDate = new Date(currentYear, currentMonth - 1, day);
    } else {
        currentDate = new Date();
        currentMonth = currentDate.getMonth();
        currentYear = currentDate.getFullYear();
    }


    const monthNames = [
        'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
        'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
    ];

    function updateCalendar(month, year) {
        const firstDay = new Date(year, month, 1);
        const lastDay = new Date(year, month + 1, 0);
        const startingDay = firstDay.getDay() || 7;
        const monthLength = lastDay.getDate();

        $.request('onGetCalendarData', {data: {month: month + 1, year: year}})
            .then((response) => {
                let calendarData = response.success ? response.items : {};
                document.querySelector('.current-month').textContent = monthNames[month];
                document.querySelector('.current-year').textContent = year;

                const calendarBody = document.querySelector('.calendar-body');
                calendarBody.innerHTML = '';

                let dayCount = 1;
                for (let i = 0; i < 6; i++) {
                    const row = document.createElement('tr');
                    for (let j = 0; j < 7; j++) {
                        const cell = document.createElement('td');
                        if (i === 0 && j < startingDay - 1 || dayCount > monthLength) {
                            cell.innerHTML = '&nbsp;';
                            cell.classList.add('empty-cell');
                        } else {
                            cell.textContent = dayCount;
                            if (calendarData[dayCount]) {
                                cell.classList.add('clickable');
                                cell.dataset.count = calendarData[dayCount];
                                cell.dataset.day = dayCount;
                                cell.dataset.year = year;
                                cell.dataset.month = month + 1;
                                cell.addEventListener('mouseenter', showTooltip);
                                cell.addEventListener('mouseleave', hideTooltip);
                                cell.addEventListener('click', navigateToNews);
                            } else {
                                cell.classList.add('non-clickable');
                            }
                            dayCount++;
                        }
                        row.appendChild(cell);
                    }
                    calendarBody.appendChild(row);
                    if (dayCount > monthLength) break;
                }
            });
    }

    function showTooltip(event) {
        document.querySelectorAll('.tooltip').forEach(t => t.remove());
        const tooltip = document.createElement('div');
        tooltip.classList.add('tooltip');
        const count = event.target.dataset.count;
        tooltip.textContent = `${count} новостей`;
        event.target.appendChild(tooltip);
        requestAnimationFrame(() => tooltip.classList.add('show'));
    }

    function hideTooltip(event) {
        const tooltip = event.target.querySelector('.tooltip');
        if (tooltip) tooltip.remove();
    }

    function navigateToNews(event) {
        const {year, month, day} = event.target.dataset;
        const date = new Date(year, month - 1, day);
        window.location.replace(`/news?date=${date.toLocaleDateString('ru-RU')}`);
    }

    document.querySelector('.prev-month').addEventListener('click', function () {
        currentMonth = currentMonth === 0 ? 11 : currentMonth - 1;
        currentYear = currentMonth === 11 ? currentYear - 1 : currentYear;
        updateCalendar(currentMonth, currentYear);
    });

    document.querySelector('.next-month').addEventListener('click', function () {
        currentMonth = currentMonth === 11 ? 0 : currentMonth + 1;
        currentYear = currentMonth === 0 ? currentYear + 1 : currentYear;
        updateCalendar(currentMonth, currentYear);
    });

    updateCalendar(currentMonth, currentYear);
}
